import { apiClient } from '../../apiClient';

const extractData = (res) => res.data;

export const reviewService = {
  getShopReviews: (shopId) => apiClient.get(`/reviews/shop/${shopId}`).then(extractData),
  createReview: (data) => apiClient.post('/reviews', data).then(extractData),
};
